import { Component, signal } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { SupportedLanguage } from "../core/product.datamodel";

/**
 * Component representing a legal notices modal
 */
@Component({
  selector: "ama-ng-legal-notices-modal",
  templateUrl: "./legalNotices.component.html",
  standalone: true,
  styleUrls: ["./legalNotices.component.scss"]
})
export class LegalNoticesComponent {
  private static readonly urlPrefix = "legalNotices/legalDocument_";
  private static readonly urlExt = ".html";
  private static readonly contentCache: Map<
    SupportedLanguage,
    SafeHtml
  > = new Map<SupportedLanguage, SafeHtml>();

  public content = signal<SafeHtml | undefined>(undefined);

  constructor(
    public activeModal: NgbActiveModal,
    private readonly http: HttpClient,
    private readonly domSanitizer: DomSanitizer
  ) {}

  /**
   * Shows legal notices content
   * @param language
   */
  public showNotices(lang: SupportedLanguage) {
    if (LegalNoticesComponent.contentCache.has(lang)) {
      this.content.set(LegalNoticesComponent.contentCache.get(lang));
    } else {
      this.loadAndShowNotices(lang);
    }
  }

  /**
   * Scrolls to the element with a given id
   * @param id
   */
  public scrollTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView();
    }
  }

  /**
   * Loads and shows legal notices content
   * @param language
   */
  private loadAndShowNotices(lang: SupportedLanguage) {
    const url: string =
      LegalNoticesComponent.urlPrefix + lang + LegalNoticesComponent.urlExt;
    this.http.get(url, { responseType: "text" }).subscribe(response => {
      const safeResponse = this.domSanitizer.bypassSecurityTrustHtml(response);
      // bypass sanitizer to preserve ids for scrolling
      LegalNoticesComponent.contentCache.set(
        lang,
        safeResponse
      );
      this.content.set(safeResponse);
    });
  }
}
